import React, { useCallback } from "react";
import Lottie from "lottie-react";
import useLottieRef from "hooks/useLottieRef";
import introAnimation from "assets/lotties/header/header_intro.json";
import loopAnimation from "assets/lotties/header/header_loop.json";
import { useLayoutContext } from "layout/layout-provider";
import CustomLottie from "../components/custom-lottie";

const Header: React.FC = () => {

  const [introHidden, setIntroHidden] = React.useState<boolean>(false);
  const { setHeaderLoaded } = useLayoutContext();

  const introCompleted = useCallback(() => {
    setIntroHidden(true);
    setHeaderLoaded(true);
  }, [setHeaderLoaded]);

  return (
    <>
      {!introHidden && (
        <CustomLottie
          animationData={introAnimation}
          loop={false}
          autoplay={true}
          className={"lottie-animation header"}
          onComplete={introCompleted}
          speed={0.5}

        />
      )}
      {introHidden && (
        <CustomLottie
          animationData={loopAnimation}
          loop={true}
          autoplay={true}
          className={"lottie-animation header"}
          speed={0.5}
        />
      )}
    </>
  );
};

export default Header;
